import { useCallback } from 'react';
import { AppDispatch, PagesRequestActions, fullstorySelectors } from '@fullstory/redux';
import { uniq } from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { PageDefinition } from '@fullstory/proto/fs/api/pages';

const { getOrgId } = fullstorySelectors;

export function usePageSearch(includeArchived = false) {
  const onSearch = useSearchActions();

  return useCallback(
    async (currentRows: PageDefinition[], currentSearch: string): Promise<PageDefinition[]> => {
      if (!currentSearch.length) {
        return currentRows;
      } else {
        const searchResults = await onSearch(currentSearch, includeArchived);
        return currentRows.filter(row => searchResults.includes(row.id));
      }
    },
    [includeArchived, onSearch],
  );
}

const useSearchActions = () => {
  const orgId = useSelector(getOrgId);
  const dispatch = useDispatch<AppDispatch>();

  const onSearch = useCallback(
    async (searchString: string, includeArchived = false) => {
      try {
        const rsp = await dispatch(
          PagesRequestActions.search({
            orgId,
            searchString,
            includeArchived,
          }),
        );
        return uniq(rsp.labelMatches.concat(rsp.nameMatches, rsp.urlMatches));
      } catch (e) {
        console.error(e);
      }
      return [];
    },
    [dispatch, orgId],
  );

  return onSearch;
};
